import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import mLaporan from '../Laporan.controler'
import moment from 'moment-timezone'
import AuthContext from '../../../../context/auth-context'
import { makeStyles } from '@material-ui/core/styles';
import { FaChevronLeft } from 'react-icons/fa';
import { Button, TableRow, TableCell, TableBody, TableHead, } from '@material-ui/core';
import PageviewIcon from '@material-ui/icons/Pageview';
import TransaksiDetail from './TransaksiDetail'

const numberWithCommas = (x) => {
    if (!x) x = 0;
    const a = parseFloat(Math.round(x * 100) / 100).toFixed(2)
    return a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const PaymentDetail = (props) => {
    const classes = useStyles();
    const [isRefresh, setIsRefresh] = useState(true)
    const { clientID, token } = useContext(AuthContext);
    const [listPayment, setlistPayment] = useState([])
    const [paymentDet, setPaymentDet] = useState({})
    const [isDetail, setIsDetail] = useState(false)
    let totalPayment = 0, totDiskon = 0, totService;

    useEffect(() => {
        if (isRefresh) {
            mLaporan.laporanPaymentDetailDiskonService(clientID, token, props.kodeoulet, props.tglDari, props.tglSampai, props.jenisdetail).then(resp => {
                setlistPayment(resp)
            }).catch(err => {
                console.error(err);
            }).finally(() => setIsRefresh(false))
        }
        return () => {
        };
    }, [isRefresh])

    const handleDetail = (data) => {
        setIsDetail(true)
        props.setIsDetHeader(false)
        setPaymentDet(data)
    }
    const handleCloseDetail = () => {
        setIsDetail(false)
        props.setIsDetHeader(true)
    }
    return (
        <React.Fragment>
            {!isDetail && (
                <Row >
                    <Col xs={12} className={`${classes.contentBody} bodySessionDetail`}>
                        <Table id="laporanPayment" striped bordered hover responsive="lg">
                            <thead>
                                <tr className="colorWhite bgHeaderTabel tabelCenter">
                                    <th>Detail Invoice</th>
                                    <th>No Invoice</th>
                                    <th>Tanggal</th>
                                    <th className="text-right">{props.jenisdetail === "diskon" ? ("Diskon") : ("Service")}</th>
                                    <th className="text-right">Jumlah</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listPayment.map((data, index) => {
                                    totalPayment += data.jumlah
                                    totDiskon += data.discountAmount
                                    totService += data.serviceAmount
                                    return (
                                        <tr className="colorWhite" key={index}>
                                            <td className="text-center">
                                                <Button title="Detail" variant="contained" className="btnRiwayatTrans" onClick={handleDetail.bind(this, data)}><PageviewIcon /></Button>
                                            </td>
                                            <td >{data.noinvoice}</td>
                                            <td>
                                                {moment(data.tanggal).format("DD-MMM-YYYY HH:mm")}
                                            </td>
                                            <td className="text-right">{props.jenisdetail === "diskon" ? (numberWithCommas(data.discountAmount)) : (numberWithCommas(data.serviceAmount))}</td>
                                            <td className="text-right">
                                                {numberWithCommas(data.jumlah)}
                                            </td>
                                        </tr>
                                    )
                                })}
                                <tr className="colorWhite">
                                    <th className="text-center" colSpan="3">Total</th>
                                    <th className="text-right">
                                        {props.jenisdetail === "diskon" ? (numberWithCommas(totDiskon)) : (numberWithCommas(totService))}
                                    </th>
                                    <th className="text-right">
                                        {numberWithCommas(totalPayment)}
                                    </th>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            )}
            {isDetail && (
                <React.Fragment>
                    <Row>
                        <Col xs={12}>
                            <div className="fixHeaderModal">
                                <h3 style={{ paddingBottom: 10 }} className="border-bottom btnBack"><FaChevronLeft onClick={handleCloseDetail} className="btnBack" />Payment Transaksi Detail </h3>
                                <h5 className="colorBlack">No Invoice : {paymentDet.noinvoice}</h5>
                            </div>
                        </Col>
                        <TransaksiDetail noinvoice={paymentDet.noinvoice} kodeoulet={props.kodeoulet} />
                    </Row>

                </React.Fragment>
            )}
            <Row className="marginGrafik"></Row>
        </React.Fragment>

    )
}


export default PaymentDetail;
const useStyles = makeStyles(theme => ({
    contentBody: {
        height: window.innerHeight - 200,
    },
}));